import styled from 'styled-components';

export const Text = styled.p`
  align-items: center;
  border: 1px solid ${props => props.color};
  border-radius: 12px;
  color: ${props => props.color};
  display: flex;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  justify-content: center;
  letter-spacing: 0.5px;
  min-width: 88px;
  margin-right: 16px;
`;
